import UserAvatarIcon from '@icons/UserAvatarIcon';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import Image from 'next/image';

export default function Avatar({ src, size = 32 }: { src?: string; size: number }) {
  return (
    <div className='flex-shrink-0'>
      {src ? (
        <Image
          className={classNames('rounded-full')}
          width={size}
          height={size}
          referrerPolicy='no-referrer'
          src={src}
          alt=''
        />
      ) : (
        <div
          className={classNames(
            'rounded-full w-full h-full flex items-center justify-center',
            setupForDark('text-icon-primary')
          )}
        >
          <UserAvatarIcon size={size} />
        </div>
      )}
    </div>
  );
}
